import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, inject, Output, signal } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { SelectClaimComponent } from "../select-claim/select-claim.component";
import { ClaimService } from '../../../../service/claim.service';
import { ClaimModel } from '../../../../interfaces/claim.model';
import { LoaderSubitoService } from '../../../../../../../shared/components/loader-subito/service/loader-subito.service';
import { LoaderSubitoComponent } from "../../../../../../../shared/components/loader-subito/loader-subito.component";
import { NotificationsService } from '../../../../../../../shared/components/notifications/service/notifications.service';
import { finalize } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'modal-send-claim',
  imports: [CommonModule, ReactiveFormsModule, SelectClaimComponent, LoaderSubitoComponent],
  templateUrl: './modal-send-claim.component.html',
  styleUrl: './modal-send-claim.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalSendClaimComponent {
  isOpen = signal(false)
  isAnimating = signal(false)
  claimService = inject(ClaimService);
  formBuilder = inject(FormBuilder);
  SpinnerService = inject(LoaderSubitoService);
  notificationService = inject(NotificationsService)
  @Output() loadEvent = new EventEmitter<void>();
  constructor(private route: ActivatedRoute,) {
    this.route.params.subscribe(params => {
      this.claimForm.patchValue({ id_order: Number(params['id']) });
    });

  }

  claimForm = this.formBuilder.group({
    id_order: [0, Validators.required],
    type: [0, Validators.required],
    description: ['', [Validators.required, Validators.minLength(10)]],
    image: [null as File | null, Validators.required],
  });

  imagePreview = signal<string | null>(null)

  onImageSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files && input.files[0];

    // Limpia previa URL si existía
    const prev = this.imagePreview();
    if (prev) {
      URL.revokeObjectURL(prev);
      this.imagePreview.set(null);
    }

    if (file) {
      const url = URL.createObjectURL(file);
      this.imagePreview.set(url);
      this.claimForm.patchValue({ image: file });
    } else {
      this.claimForm.patchValue({ image: null });
    }
  }

  // Patrón idéntico al modal que funciona (modal-view-rate)
  openModal(): void {
    if (this.isOpen()) {
      this.closeModalWithAnimation();
    } else {
      this.openModalWithAnimation();
    }
  }

  openModalWithAnimation(): void {
    this.isOpen.set(true);
    setTimeout(() => {
      this.isAnimating.set(true);
    }, 10);
  }

  closeModal(): void {
    this.claimForm.reset();
    this.closeModalWithAnimation();
  }

  closeModalWithAnimation(): void {
    this.isAnimating.set(false);
    setTimeout(() => {
      this.isOpen.set(false);
      const prev = this.imagePreview();
      if (prev) {
        URL.revokeObjectURL(prev);
        this.imagePreview.set(null);
      }
      this.claimForm.patchValue({ image: null });
    }, 300);
  }

  OnSendClaim(): void {
    this.claimForm.markAllAsTouched();
    if (this.claimForm.invalid) {
      this.notificationService.addNotification({
        message: 'Por favor complete los campos requeridos correctamente',
        type: 'error',
        duration: 3000,
      });
      return;
    }

    this.SpinnerService.showLoader()
    this.claimService.reportProblem(this.getClaimForm()).pipe(
      finalize(() => {
        this.SpinnerService.hideLoader()
      })
    ).subscribe({
      next: (response: { success: boolean, message: string }) => {
        this.notificationService.addNotification({
          message: response.message as string,
          type: 'success',
          duration: 3000,
        })
         this.claimForm.reset();
        this.loadEvent.emit();
      },
      error: (err) => {
        // console.log(err);
      },
      complete: () => {
        this.claimForm.reset();
        this.closeModal();
      }
    })
  }

  onSelectClaim(claim: string): void {
    this.claimForm.patchValue({ type: Number(claim) });
  }



  getClaimForm(): ClaimModel {
    return {
      id_order: this.claimForm.value.id_order || 0,
      type: this.claimForm.value.type || 0,
      description: this.claimForm.value.description || '',
      image: this.claimForm.value.image!,
    }
  }
}

